global.ajaxFormRequests = {};

global.ajaxForm = function(options) {
    if (options.messages !== false) {
        loadingBox(true);
    }

    // Default
    if (!options.method) options.method = 'POST'        // POST, GET
    if (!options.dataType) options.dataType = 'json'    // json, html, xml, script, text

    var form = $(options.form);

    // fix url
    if (options.url) options.url = options.url.replace(/(?<!:)\/{2,}/g, "/");

    // form detection
    if (options.target) {
        if ($(options.target)[0] && $(options.target)[0].tagName == 'FORM') {
            form = $(options.target);
        }
        else form = $(options.target).parents('form');
    }

    /* -- Part 1 - Data source -- */
    // From FORM
    if (!options.data) {
        var data = new Array();
        var abortForm = false;

        // Form loop
        form.each(function( index, item ) {
            var errors = formValidation(item);
            // Validation post process
            $.each(errors, function(key) {
                if (this && this.test) {
                    // Issue - Remove error
                    if (this.field.hasClass('tested--success')) {
                        errors.splice(key, 1);
                    }
                    // Issue - Add error
                    else if (this.field.hasClass('tested--error')) {
                        errors[key]['message'] = this.field.data('error');
                        abortForm = true;
                        return false;
                    }
                    // Issue - Require Ajax test
                    else if (!this.field.hasClass('tested')) {
                        if (!abortForm) {
                            abortForm = true;
                            var field = this.field;
                            var dataTest = {};
                            dataTest[this.field.attr('name')] = this.field.val();
                            $.ajax({
                                url: this.test,
                                form: form,
                                type: options.method,
                                data: JSON.stringify([dataTest]),
                                dataType: 'json',
                                contentType: "application/json; charset=utf-8",
                                success: function (data) {
                                    // Test success
                                    if (data.status == 'success') {
                                        field.addClass('tested').addClass('tested--success');
                                    }
                                    // Test failure
                                    else {
                                        field.addClass('tested').addClass('tested--error').data('error', data.message);
                                    }
                                    // debugger;
                                    ajaxForm(options);
                                },
                                error: function (data) {
                                    // Test fatal
                                    field.addClass('tested').addClass('tested--error').data('error', 'Validation impossible');
                                }
                            });
                            errors.splice(key, 1);
                            return false;
                        }
                    }
                }
            });

            // Display errors
            if (errors.length && !abortForm) {
                formShowError(item, errors);
                if (options.messages !== false) {
                    loadingBox(false);
                    msg('warning', 'Le formulaire contient des erreurs.');
                }
                abortForm = true;
            }
            data.push(getFormData(item));

            // Recaptcha test
            var recaptchaField = $(item).find('.recaptcha');
            if (!abortForm && recaptchaField.length && !recaptchaField.val() && recaptchaField.closest('.private').length == 0) {
                abortForm = true;
                grecaptcha.execute();
                loadingBox(false);
                recaptchaField.data('submit', function() {options.target.click()});
                return false;
            }
        });
        // Validation failure - cancel request
        if (abortForm) {
            if (options.error) {
                options.error(data, form);
            }

            if (options.end) {
                options.end(data, form);
            }
            return false;
        }
    }
    // From DATA option
    else {
        data = options.data;
    }

    /* -- Part 2 - Prepare Request -- */
    // Live mode (experimental)
    if (typeof Server !== 'undefined' && Server) {
        var liveData = {
            url: options.url,
            form: form,
            type: options.method,
            data: data
        }
        Server.send('message', JSON.stringify(liveData));
    }
    // Ajax mode
    else {
        var requestData = {
            url: options.url,
            form: form,
            type: options.method,
            data: (data && (data.length > 0 || typeof data == 'object'))?JSON.stringify(data):null,
            dataType: options.dataType,
            contentType: "application/json; charset=utf-8",
        };

        /* -- Part 3 - Callback -- */
        // COMPLETE
        requestData.complete = function (data) {
            if (options.end) options.end(data, form);
            if (options.messages !== false) loadingBox(false);
        }

        // ERROR
        requestData.error = function (data) {
            if (options.error) options.error(data, form);

            var recaptchaField = $('.recaptcha');
            if (recaptchaField.length) {
                recaptchaField.val('');
                grecaptcha.reset();
            }
        }

        // SUCCESS
        requestData.success = function (data) {
            var selector = options.selector;
            var abort = false;
            if (unloadBlock(selector) === false) abort = true;

            try {
                //data = JSON.parse(data);
                if (data.message && options.messages !== false && data.message && data.message.toLowerCase() != 'ok') {
                    msg(data.status, data.message);
                }

                // paramètre d'interruption
                if (data.abort) {
                    abort = true;
                }

                // paramètre d'interruption
                if (data.reload == 'lastPage' || options.reload == 'lastPage') {
                    abort = true;
                    if (lastPageMode == 'history') {
                        pageCache = {};
                        history.go(-1);
                    }
                    else {
                        location.href = document.referrer;
                    }
                }
                else {
                    // paramètre de vidage
                    if (data.clear) {
                        clearZone(selector, true);
                    }
                }

                if (data.status != 'error') {

                    // Patching
                    if (options.patch) {
                        var patchTargets = [];

                        if (options.patch === true || options.patch === 1) {
                            if (selector) patchTargets.push([selector, selector]);
                        } else if (Array.isArray(options.patch)) {
                            if (options.patch.length > 0 && Array.isArray(options.patch[0])) {
                                // Cas [[sélecteurPage, sélecteurDonnées], ...]
                                patchTargets = options.patch;
                            } else {
                                // Cas [query1, query2, ...]
                                patchTargets = options.patch.map(function(item) {
                                    return [item, item];
                                });
                            }
                        } else if (typeof options.patch === 'string') {
                            patchTargets = [[options.patch, options.patch]];
                        }

                        if (patchTargets.length > 0) {
                            var htmlContent = (typeof data === 'object' && data.html) ? data.html : data;
                            if (typeof htmlContent === 'string') {
                                var $responseHtml = $('<div>').append($.parseHTML(htmlContent));

                                $.each(patchTargets, function(i, pair) {
                                    var pageSelector = pair[0];
                                    var dataSelector = pair[1];
                                    var $newElement;

                                    if (dataSelector === true || dataSelector === 1) {
                                        $newElement = $responseHtml.contents();
                                    } else {
                                        $newElement = $responseHtml.find(dataSelector).html();
                                    }

                                    if ($newElement.length) {
                                        var $currentTarget = $(pageSelector);

                                        if ($currentTarget.length) {
                                            if (typeof BEHAV !== 'undefined' && BEHAV) BEHAV.apply($currentTarget, 'unload');
                                            $currentTarget.html($newElement);
                                            if (typeof initBlock === 'function' && initBlock($currentTarget) === false) abort = true;
                                        }
                                    }
                                });
                            }
                        }
                    }

                    if (options.callback) {
                        options.callback(data, form);
                    }
                    if (options.success) {
                        options.success(data, form);
                    }
                }
                else {
                    requestData.error(data, form);
                }
            }
            catch (e) {
                log(e);
                msg('error', e)

                if (selector) {
                    if (BEHAV) BEHAV.apply(selector, 'unload');
                    $(selector).html(data);
                    if (typeof initBlock === 'function' && initBlock(selector) === false) abort = true;
                }

                // scrolling
                if (options.scroll) {
                    scrollTo(selector);
                }
            }
        }

        /* -- Part 4 - Append files -- */
        if (data[0] && data[0]._files && !options.files) {
            options.files = data[0]._files;
            options.data = data[0];
        }

        if (options.files) {
            var formData = new FormData();
            $.each(options.data, function(dataIndex, dataVal) {
                if (dataIndex != '_files') {
                    if (typeof dataVal === 'object' && dataVal !== null && !(dataVal instanceof File) && !(dataVal instanceof Blob)) {
                        formData.set(dataIndex, JSON.stringify(dataVal));
                    } else {
                        formData.set(dataIndex, dataVal);
                    }
                }
            });
            $.each(options.files, function(fileIndex, fileData) {
                formData.append(fileIndex, fileData);
            });
            requestData.dataType = 'json';
            requestData.cache = false;
            requestData.contentType = false;
            requestData.processData = false;
            requestData.data = formData;
        }

        /* -- Part 5 - Cleanup -- */
        if (requestData.data == '[]') delete requestData.data;

        /* -- Part 6 - Launch query -- */
        if (options.debounce) {
            if (global.ajaxFormRequests[options.debounce]) {
                loadingBox(false);
                clearTimeout(global.ajaxFormRequests[options.debounce]);
            }
            global.ajaxFormRequests[options.debounce] = setTimeout(function() {
                var request = $.ajax(requestData);
                global.ajaxFormRequests[options.debounce] = null;
            }, (options.delay) ? options.delay : 200)
        }
        else {
            var request = $.ajax(requestData);
        }
    }
}


global.ajaxStack = function(requests) {
    var options = requests[0];
    requestParams = '';
    //var requestParams = 'ajax=1&'+jsonToUrl(requests[0]);
    //requestParams += get_form();
    if (options['raw']) {requestParams += '&'+options['raw'];}

    options.type = 'GET'
    options.dataType = 'HTML'
    options.data = requestParams

    ajaxForm(options);
}

global.debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
}

global.load_binary_resource = function(url) {
    var req = new XMLHttpRequest();
    req.open('GET', url, false);
    //XHR binary charset opt by Marcus Granado 2006 [http://mgran.blogspot.com]
    req.overrideMimeType('text\/plain; charset=x-user-defined');
    req.send(null);
    if (req.status != 200) return '';
    return req.responseText;
}
